import React from 'react';
import GoogleLoginMine from '../utils/GoogleLoginMine';
import AppleLoginOnly from './AppleLoginOnly';
import './Login.css';

const Login = () => {
  return (
    <div className="login-container">
      <div className="login-content">
        <h1 className="login-title">Welcome Back</h1>
        <p className="login-message">
          Please log in to update account details
        </p>
        <div className="login-options">
          <GoogleLoginMine />

          <div className="login-divider">
            <span>or</span>
          </div>
          <AppleLoginOnly />
        </div>
      </div>
    </div>
  );
};

export default Login; 